<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="800"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-text>
                    <template>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field v-model="provider" label="Proveedor" color="blue" hide-details></v-text-field>
                                <v-btn x-small dark color="green darken-2" height="30" @click="handleNewProvider">
                                    <v-icon size="12" dark>fas fa-plus</v-icon>
                                </v-btn>
                            </v-col>

                            <v-col cols="3">
                                <v-text-field v-model="document" label="Nro comprobante" color="blue" hide-details></v-text-field>
                            </v-col>

                            <v-col cols="3">
                                <v-menu
                                    v-model="menuEntryDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                        v-model="entry_date"
                                        label="Fecha de comprobante"
                                        readonly
                                        clearable
                                        v-on="on"
                                        @click:clear="entry_date=null"
                                        hide-details=""
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="entry_date" @input="menuEntryDate = false" no-title></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>                
            </v-card>

            <v-card class="mt-3">
                <v-card-text>
                    <template>
                        <v-row>
                            <v-col cols="6">
                                <v-autocomplete
                                    v-model="values"
                                    :items="supplies"
                                    dense                                    
                                    label="Insumo"
                                    :item-text="customText"
                                    hide-details=""                            
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field v-model="quantity" label="Cantidad" type="number" hide-details></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field v-model="price" label="Precio" type="number" hide-details></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-btn small block>
                                    Añadir
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>

            <v-card class="mt-3">
                <v-card-subtitle>
                    <span class="subtitle-2">Items de compra</span>
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text>
                    <template>
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    class="wost-table"
                                    :headers="headers"
                                    :items="items"
                                    hide-default-footer
                                    item-key="name"
                                    height="35vh"
                                    no-data-text=""
                                >
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>

            <div class="mt-3" style="text-align: right;">
                <v-btn @click="handleCancel">
                    Cancelar
                </v-btn>
                <v-btn class="ml-3" dark color="primary">
                    Guardar
                </v-btn>
            </div>
        </div>
        <create-provider ref="createProvider"></create-provider>
    </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import CreateProvider from '../Providers/CreateProvider'

export default {
    name: 'Entry',
    components: {
        CreateProvider
    },
    computed: {
        ...mapState('production', [
            'supplies'
        ])
    },
    data() {
        return {
            titleForm: '',
            drawer: false,
            actionCrud: '',
            entry_date: null,
            provider: null,
            menuEntryDate: false,
            document: null,
            quantity: null,
            price: null,
            items: [],
            headers: [
                { text: 'Insumo', value: 'name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'P. Compra', value: 'category_id', align: 'left', sortable: false, class: 'header-table', width: 100 },
                { text: 'Cantidad', value: 'unit_id', align: 'left', sortable: false, class: 'header-table', width: 100},
                { text: 'Subtotal', value: 'stock', align: 'a-right', sortable: false, class: 'header-table', width: 100},
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', width: 35 }
            ]
        }
    },
    methods:{
        showForm(title) {
            this.titleForm = title
            this.drawer = !this.drawer
        },
        customText(item){
            let text = item.name

            return text
        },
        handleCancel(){
            this.drawer = false
        },
        handleNewProvider(){
            this.$refs.createProvider.showForm('Nuevo Proveedor')
        }
    }
}
</script>

<style>

</style>